import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import first from '../images/first.png';
import second from '../images/second.png';
import third from '../images/third.png';
import badge from '../images/badge.png';

export default function LeaderboardAccount(props) {

	const [place, setPlace] = useState(props.place)
	const [imgsrc, setImgsrc] = useState("")


	useEffect(() => {
		var pt = "1st"
		var imgsrc = first;
		switch(place){
		case 2:
			pt = "2nd"
			imgsrc = second;
			break;
		case 3:
			pt = "3rd"
			imgsrc = third;
			break;
		case 4:
			pt = "4th"
			imgsrc = badge;
			break;
		case 5:
			pt = "5th"
			imgsrc = badge;
			break;
		}

		setPlaceText(pt)
		setImgsrc(imgsrc)
	})
	

	const [placeText, setPlaceText] = useState("");

	return (
		<div className="leaderboard-entry first-place">
			<img src={imgsrc}/>
			<h2>{placeText}</h2>
			<p className="leaderboard-user">{props.name}</p>
			<p>{props.points} pts</p>
		</div>
	)
}

LeaderboardAccount.propTypes = {
	place: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	points: PropTypes.number.isRequired
}